// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!../BreadcrumbTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BreadcrumbLink-module__Link__aqkN0 {
    display: flex;
    gap: var(--ds-s);
    min-width: var(--ds-m);
    max-width: var(--ds-64x);
    color: var(--ds-breadcrumb-link-color);
    /* stylelint-disable-next-line property-disallowed-list -- DS component */
    line-height: var(--ds-line-height-big);
    cursor: pointer;

    &:focus-visible {
        border-radius: var(--ds-border-radius-s);
        outline: var(--ds-link-color-outline) solid var(--ds-border-width-focus);
        outline-offset: var(--ds-xs);
    }

    &:hover {
        color: var(--ds-breadcrumb-link-hover-color);
    }
}

.BreadcrumbLink-module__LinkNoEllipsis__kWF0m {
    flex-shrink: 0;
}

.BreadcrumbLink-module__LinkText__Ipd6U {
    overflow: hidden;
    /* stylelint-disable-next-line property-disallowed-list -- DS component */
    font-weight: var(--ds-font-weight-medium);
    white-space: nowrap;
}

.BreadcrumbLink-module__LinkTextEllipsis__sWSRv {
    text-overflow: ellipsis;
}

.BreadcrumbLink-module__LinkTextNoEllipsis__GUwP0 {
    flex-shrink: 0;
}

.BreadcrumbLink-module__Current__hYjmM {
    flex-shrink: 0;
    max-width: var(--ds-64x);
    color: var(--ds-breadcrumb-link-current-color);
    /* stylelint-disable-next-line property-disallowed-list -- DS component */
    line-height: var(--ds-line-height-big);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Link": `BreadcrumbLink-module__Link__aqkN0`,
	"LinkNoEllipsis": `BreadcrumbLink-module__LinkNoEllipsis__kWF0m`,
	"LinkText": `BreadcrumbLink-module__LinkText__Ipd6U`,
	"LinkTextEllipsis": `BreadcrumbLink-module__LinkTextEllipsis__sWSRv`,
	"LinkTextNoEllipsis": `BreadcrumbLink-module__LinkTextNoEllipsis__GUwP0`,
	"Current": `BreadcrumbLink-module__Current__hYjmM`
};
export default ___CSS_LOADER_EXPORT___;
